import { Timeoff } from '../tabs/Timeoff';
import { HashRouter as Router, Route, Routes } from 'react-router-dom';
import { ServerErrorPage } from 'src/pages/ServerErrorPage';
import { Goals } from 'src/tabs/Goals';
import { Skills } from 'src/tabs/Skills';
import { Timesheets } from 'src/tabs/Timesheets';
import { Feedback } from '../tabs/Feedback';
import { ServiceDesk } from 'src/tabs/ServiceDesk';

export const AppRouter = () => {
  return (
    <Router>
      <Routes>
        <Route path="/time-off" element={<Timeoff />} />
        <Route path="/timesheets" element={<Timesheets />} />
        <Route path="/skills" element={<Skills />} />
        <Route path="/goals" element={<Goals />} />
        <Route path="/feedback" element={<Feedback />} />
        <Route path="/service-desk" element={<ServiceDesk />} />
        <Route path="*" element={<ServerErrorPage />} />
      </Routes>
    </Router>
  );
};
